import { Text } from "@fluentui/react-components";

import { Edit24Regular, FormNew24Regular } from "@fluentui/react-icons";

import { useCategoryDrawerStore } from "../store/CategoryDrawerStore";

import BaseDrawer from "../../../components/BaseDrawer";
import CategoryForm from "./CategoryForm";
import { useDeleteCategoryMutation } from "../api/Delete";
import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useCategoryContext } from "../context/CategoryContext";
import OverlaySpinner from "../../../components/OverlaySpinner";

export default function CategoryDrawer() {
    const { isEdit, isOpen, close, data } = useCategoryDrawerStore();
    const { showDialog, showNotification } = useUtilitiesContext();
    const { refetchCategories } = useCategoryContext();

    const deleteMutation = useDeleteCategoryMutation(
        () => {
            showNotification({
                type: "success",
                title: "Deleted",
                message: <Text>The category <b>{data?.name}</b> is pending approval for deletion.</Text>,
                
            });
            refetchCategories();
            close();
        },
        (error: Error) => {
            showNotification({
                type: "error",
                title: "Error",
                message: error.message,
            });
        }
    );
    const handleDelete = () => {
        if (data) {
            showDialog({
                title: "Delete Option",
                content: <Text>Are you sure you want to delete option <b>{data.name}</b> ?</Text>,
                primaryActionText: "Yes",
                primaryAction: () => deleteMutation.mutate(data.id),
                secondaryActionText: "No",
                secondaryAction: () => { },
            });
        }
    };

    const drawerTitle = isEdit ? "Edit category" : "New category";
    const drawerIcon = isEdit ? <Edit24Regular /> : <FormNew24Regular />;

    return (
        <BaseDrawer
            title={drawerTitle}
            icon={drawerIcon}
            size="small"
            isOpen={isOpen}
            close={close}
            removable={isEdit}
            remove={handleDelete}
        >
            <OverlaySpinner open={deleteMutation.isPending} label="Deleting..." />
            <CategoryForm />
        </BaseDrawer>
    )
}